import {request} from '../request';
import {DataSplitType} from '../../types/dataset/Dataset';
import {DeploymentType} from '../../types/deployment/DeploymentType';
import {Deployment} from '../../types/deployment/DeploymentResponse';
import {Points} from '../../types/deployment/StreamingDeviceResponse';
import {InputSource} from '../../types/deployment/InferenceInputSource';
import {AnalyticsParametersAnswer} from '../../types/prompts/AnalyticsParameters';

type BaseTestRequest = {
  projectId: string;
  applicationId: string;
  schedulerId?: string;
  name: string;
  description: string;
};

export type OnnxTestReport = BaseTestRequest & {
  deploymentType: DeploymentType;
  inputSourceType?: InputSource | null;
};

type TestTextInferenceRequest = BaseTestRequest & {
  streamingSessionId?: string | null;
};

type BaseVideoStreamRequest = BaseTestRequest & {
  spaId?: string;
  environment?: Record<string, string>;
  analyticsParameters?: AnalyticsParametersAnswer;
};

type TestWebCameraVideoStreamRequest = BaseVideoStreamRequest & {
  streamingSessionId?: string | null;
};

type TestExternalVideoStreamRequest = BaseVideoStreamRequest & {
  inputSourceType?: InputSource | null;
  streamingUrl?: string | null;
  lines?: Points[];
  regions?: Points[];
};

type BaseImageInferenceRequest = BaseTestRequest & {
  environment?: Record<string, string>;
  analyticsParameters?: AnalyticsParametersAnswer;
  tilingWidth?: number | null;
  tilingHeight?: number | null;
};

type TestImageValidationRequest = BaseImageInferenceRequest & {
  deploymentType: DeploymentType;
  splitType?: DataSplitType | null;
};

type TestImageInferenceRequest = BaseImageInferenceRequest & {
  inferenceDataId?: string;
};

type TestImageSetsInferenceRequest = BaseImageInferenceRequest & {
  inferenceDataId?: string;
};

export type TestInitiateRequest = {
  textInferenceRequest?: TestTextInferenceRequest;
  webCameraVideoInferenceRequest?: TestWebCameraVideoStreamRequest;
  externalVideoInferenceRequest?: TestExternalVideoStreamRequest;
  imageValidationRequest?: TestImageValidationRequest;
  imageInferenceRequest?: TestImageInferenceRequest;
  imageSetsInferenceRequest?: TestImageSetsInferenceRequest;
};

export async function postTestInitiate(data: TestInitiateRequest) {
  return request<Deployment>({
    method: 'post',
    url: '/gsp/test/initiate',
    data,
  });
}

export async function postTestOnnxReport(data: OnnxTestReport) {
  return request<Deployment>({
    method: 'post',
    url: '/gsp/test/onnx/save',
    data,
  });
}
